import React, { useState } from 'react';

const activities = [
    { id: 1, user: 'Rahul Sharma', role: 'Super Admin', action: 'approved', target: 'Dark Secrets - Ep 37', type: 'moderation', time: '2 minutes ago', icon: 'fas fa-check-circle', color: '#10b981' },
    { id: 2, user: 'Priya Patel', role: 'Content Manager', action: 'uploaded', target: '3 new episodes to Love in Seoul', type: 'content', time: '15 minutes ago', icon: 'fas fa-upload', color: '#6366f1' },
    { id: 3, user: 'System', role: 'Automated', action: 'processed', target: '1,240 coin purchases ($4,820 revenue)', type: 'revenue', time: '30 minutes ago', icon: 'fas fa-coins', color: '#f59e0b' },
    { id: 4, user: 'Amit Kumar', role: 'Finance Manager', action: 'updated', target: 'VIP Weekly plan price to $4.99', type: 'settings', time: '1 hour ago', icon: 'fas fa-edit', color: '#f82581' },
    { id: 5, user: 'Vikram Singh', role: 'Support Agent', action: 'resolved', target: 'Ticket #4521 - Payment issue', type: 'support', time: '1 hour ago', icon: 'fas fa-ticket-alt', color: '#06b6d4' },
    { id: 6, user: 'Sneha Gupta', role: 'Content Manager', action: 'created', target: 'New series: Midnight Romance (24 episodes)', type: 'content', time: '2 hours ago', icon: 'fas fa-plus-circle', color: '#8b5cf6' },
    { id: 7, user: 'System', role: 'Automated', action: 'sent', target: 'Push notification to 12,400 users about new content', type: 'notification', time: '3 hours ago', icon: 'fas fa-bell', color: '#ec4899' },
    { id: 8, user: 'Rahul Sharma', role: 'Super Admin', action: 'rejected', target: 'Series: Toxic Love - content policy violation', type: 'moderation', time: '3 hours ago', icon: 'fas fa-times-circle', color: '#ef4444' },
    { id: 9, user: 'Deepa Nair', role: 'Content Manager', action: 'updated', target: 'Series thumbnail for Campus Queen', type: 'content', time: '4 hours ago', icon: 'fas fa-image', color: '#6366f1' },
    { id: 10, user: 'System', role: 'Automated', action: 'generated', target: 'Daily analytics report for Feb 17, 2026', type: 'analytics', time: '5 hours ago', icon: 'fas fa-chart-bar', color: '#10b981' },
    { id: 11, user: 'Karan Mehta', role: 'Support Agent', action: 'assigned', target: 'Ticket #4523 to Vikram Singh', type: 'support', time: '5 hours ago', icon: 'fas fa-exchange-alt', color: '#06b6d4' },
    { id: 12, user: 'Priya Patel', role: 'Content Manager', action: 'published', target: "CEO's Heart - Episode 41 now live", type: 'content', time: '6 hours ago', icon: 'fas fa-rocket', color: '#f82581' },
    { id: 13, user: 'System', role: 'Automated', action: 'distributed', target: '8,100 free coins via daily check-in rewards', type: 'revenue', time: '8 hours ago', icon: 'fas fa-gift', color: '#f59e0b' },
    { id: 14, user: 'Amit Kumar', role: 'Finance Manager', action: 'exported', target: 'Monthly revenue report (January 2026)', type: 'analytics', time: '10 hours ago', icon: 'fas fa-file-download', color: '#10b981' },
    { id: 15, user: 'Rahul Sharma', role: 'Super Admin', action: 'invited', target: 'Kavita Das as Support Agent', type: 'team', time: '12 hours ago', icon: 'fas fa-user-plus', color: '#8b5cf6' },
    { id: 16, user: 'System', role: 'Automated', action: 'flagged', target: '2 series for content review', type: 'moderation', time: '1 day ago', icon: 'fas fa-flag', color: '#ef4444' },
    { id: 17, user: 'Sneha Gupta', role: 'Content Manager', action: 'updated', target: 'Genre categories - added "Office Romance"', type: 'content', time: '1 day ago', icon: 'fas fa-tags', color: '#6366f1' },
    { id: 18, user: 'System', role: 'Automated', action: 'renewed', target: '342 VIP subscriptions auto-renewed', type: 'revenue', time: '1 day ago', icon: 'fas fa-sync-alt', color: '#f59e0b' },
    { id: 19, user: 'Vikram Singh', role: 'Support Agent', action: 'resolved', target: 'Ticket #4518 - Playback issue on Android', type: 'support', time: '1 day ago', icon: 'fas fa-mobile-alt', color: '#06b6d4' },
    { id: 20, user: 'Rahul Sharma', role: 'Super Admin', action: 'updated', target: 'Firebase notification configuration', type: 'settings', time: '2 days ago', icon: 'fas fa-cog', color: '#f82581' },
];

const typeFilters = [
    { key: 'all', label: 'All Activity', icon: 'fas fa-list' },
    { key: 'content', label: 'Content', icon: 'fas fa-film' },
    { key: 'moderation', label: 'Moderation', icon: 'fas fa-shield-alt' },
    { key: 'revenue', label: 'Revenue', icon: 'fas fa-dollar-sign' },
    { key: 'support', label: 'Support', icon: 'fas fa-headset' },
    { key: 'analytics', label: 'Analytics', icon: 'fas fa-chart-line' },
    { key: 'settings', label: 'Settings', icon: 'fas fa-cog' },
    { key: 'team', label: 'Team', icon: 'fas fa-users' },
    { key: 'notification', label: 'Notifications', icon: 'fas fa-bell' },
];

const ActivityFeed = () => {
    const [filter, setFilter] = useState('all');
    const [search, setSearch] = useState('');

    const filtered = activities.filter(a => {
        const matchType = filter === 'all' || a.type === filter;
        const matchSearch = search === '' || a.target.toLowerCase().includes(search.toLowerCase()) || a.user.toLowerCase().includes(search.toLowerCase());
        return matchType && matchSearch;
    });

    const getInitials = (name) => {
        if (name === 'System') return 'SYS';
        return name.split(' ').map(n => n[0]).join('').toUpperCase();
    };

    const todayCount = activities.filter(a => a.time.includes('minute') || a.time.includes('hour')).length;
    const contentActions = activities.filter(a => a.type === 'content').length;
    const moderationActions = activities.filter(a => a.type === 'moderation').length;

    return (
        <section className="activity-section section">
            <div className="activity-header">
                <div>
                    <h4>Activity Feed</h4>
                    <p className="activity-subtitle">Real-time log of all admin actions and system events</p>
                </div>
                <div className="activity-header-stats">
                    <div className="activity-stat-pill">
                        <i className="fas fa-bolt" style={{ color: '#f59e0b' }}></i>
                        <span>{todayCount} today</span>
                    </div>
                    <div className="activity-stat-pill">
                        <i className="fas fa-film" style={{ color: '#6366f1' }}></i>
                        <span>{contentActions} content</span>
                    </div>
                    <div className="activity-stat-pill">
                        <i className="fas fa-shield-alt" style={{ color: '#f82581' }}></i>
                        <span>{moderationActions} moderation</span>
                    </div>
                </div>
            </div>

            <div className="activity-controls">
                <div className="activity-search">
                    <i className="fas fa-search"></i>
                    <input type="text" placeholder="Search activities..." value={search} onChange={(e) => setSearch(e.target.value)} />
                </div>
                <div className="activity-type-filters">
                    {typeFilters.map(tf => (
                        <button key={tf.key} className={`activity-type-btn ${filter === tf.key ? 'active' : ''}`} onClick={() => setFilter(tf.key)}>
                            <i className={tf.icon}></i>
                            <span>{tf.label}</span>
                        </button>
                    ))}
                </div>
            </div>

            <div className="activity-timeline">
                {filtered.map((activity, idx) => (
                    <div key={activity.id} className="activity-item" style={{ animationDelay: `${idx * 0.03}s` }}>
                        <div className="activity-connector">
                            <div className="activity-dot" style={{ background: activity.color }}></div>
                            {idx < filtered.length - 1 && <div className="activity-line"></div>}
                        </div>
                        <div className="activity-card">
                            <div className="activity-card-header">
                                <div className="activity-user-info">
                                    <div className="activity-avatar" style={{ background: `${activity.color}20`, color: activity.color }}>
                                        {activity.user === 'System' ? <i className="fas fa-robot"></i> : getInitials(activity.user)}
                                    </div>
                                    <div>
                                        <strong>{activity.user}</strong>
                                        <span className="activity-role">{activity.role}</span>
                                    </div>
                                </div>
                                <span className="activity-time"><i className="fas fa-clock"></i> {activity.time}</span>
                            </div>
                            <div className="activity-card-body">
                                <div className="activity-action-icon" style={{ background: `${activity.color}15`, color: activity.color }}>
                                    <i className={activity.icon}></i>
                                </div>
                                <p>
                                    <span className="activity-action-word">{activity.action}</span> {activity.target}
                                </p>
                            </div>
                        </div>
                    </div>
                ))}
                {filtered.length === 0 && (
                    <div className="activity-empty">
                        <i className="fas fa-stream"></i>
                        <h5>No activities found</h5>
                        <p>Try adjusting your filters or search terms</p>
                    </div>
                )}
            </div>
        </section>
    );
};

export default ActivityFeed;
